export const slugify = (str) => {
	return String(str)
		.normalize('NFKD') // split accented characters into their base characters and diacritical marks
		.replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
		.trim() // trim leading or trailing whitespace
		.toLowerCase() // convert to lowercase
		.replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
		.replace(/\s+/g, '-') // replace spaces with hyphens
		.replace(/-+/g, '-') // remove consecutive hyphens
}

export const urlify = (string: string) => encodeURIComponent(string.replace(/\r\n|\r|\n|\t/gm, ''))

export const emailIsValid = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
export const phoneNumberIsValid = (phoneNumber:string) => /^(\+\d{1,4}?\s?)?((\(\d{1,4}\))\s?)?\d{1,14}$/.test(phoneNumber)
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i.source
export const PHONE_PATTTERN = /^\d{7,15}$/.source

export const replaceWithMap = (str, mapObj) => {
	const keys = Object.keys(mapObj)
	if (!keys.length) return str
	const regexp = new RegExp(keys.join('|').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'gi')
	return str.replace(regexp, (matched) =>
		mapObj[decodeURIComponent(matched).toLowerCase()],
	)
}

export const getFlagEmoji = (countryCode: string) => {
	const codePoints = countryCode
		.toUpperCase()
		.split('')
		.map(char => 127397 + char.charCodeAt(0))
	return String.fromCodePoint(...codePoints)
}
